import { ReactNode } from "react";
import {
  AudioIcon,
  CodeIcon,
  DocumentIcon,
  FolderIcon,
  ImageIcon,
  PdfIcon,
  SpreadsheetIcon,
  Video01Icon,
  Video02Icon
} from "./icons";

type MimeTypeInfo = {
  icon: ReactNode | null
  type: MimeTypeEnum
}

export enum MimeTypeEnum {
  IMAGE = "image",
  AUDIO = "audio",
  VIDEO = "video",
  TEXT = "text",
  FONT = "font",
  APPLICATION_PDF = "applicationPdf",
  APPLICATION = "application",
  CODE = "code",
  FOLDER = "folder",
  DEFAULT = ""
}

const codeMimePatterns = [ "html", "javascript", "php", "x-java-source", "css", "json" ];
const defaultMimeTypeInfo: MimeTypeInfo = { icon: null, type: MimeTypeEnum.DEFAULT };

export const getExtension = (fileExtension: string | undefined) => {
  const shortExtension = fileExtension?.split(".").pop();
  return shortExtension?.toUpperCase();
};

const codeMimeRegex = new RegExp(`\\b(${codeMimePatterns.join("|")})\\b`);

export const getType = (mimeType?: string) => {
  if (mimeType) {
    if (/^application\/pdf/.test(mimeType)) return "applicationPdf";

    if (codeMimeRegex.test(mimeType)) return "code";

    return mimeType?.split("/").shift();
  }
};

const getMimeIcon = (mime?: string, videoIconType?: string) => {
  switch (mime) {
    case MimeTypeEnum.IMAGE: return <ImageIcon />;
    case MimeTypeEnum.AUDIO: return <AudioIcon />;
    case MimeTypeEnum.VIDEO: return videoIconType === "video01" ? <Video01Icon /> : <Video02Icon />;
    case MimeTypeEnum.TEXT:
    case MimeTypeEnum.FONT: return <DocumentIcon />;
    case MimeTypeEnum.APPLICATION_PDF: return <PdfIcon />;
    case MimeTypeEnum.APPLICATION: return <SpreadsheetIcon />;
    case MimeTypeEnum.CODE: return <CodeIcon />;
    default: return null
  }
}

export const getMimeTypeInfo = (
  mimeType: string | undefined,
  isFolder: boolean,
  videoIconType: string
): MimeTypeInfo => {
  if (isFolder) return { icon: <FolderIcon />, type: MimeTypeEnum.FOLDER };

  const type= getType(mimeType);

  const icon = getMimeIcon(type, videoIconType)

  return type ? { icon, type } as MimeTypeInfo : defaultMimeTypeInfo;
};
